import { lazy, Suspense, useEffect } from "react";

const ScrollIndicator = lazy(() => import("@/components/ScrollIndicator"));

const Hero = () => {
  // Enhance the static HTML hero with smooth-scroll behavior and hide raw anchor fallbacks
  useEffect(() => {
    const buttonsContainer = document.getElementById("static-hero-buttons");
    if (!buttonsContainer) return;

    const links = buttonsContainer.querySelectorAll("a");
    links.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const href = link.getAttribute("href");
        if (href) {
          document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
        }
      });
    });
  }, []);

  return (
    <>
      {/* Scroll indicator appended after the static hero */}
      <Suspense fallback={null}>
        <ScrollIndicator />
      </Suspense>
    </>
  );
};

export default Hero;
